fragment DataAccessPolicyFields on DataAccessPolicy {
  __typename
  id
  name
  description
  _rowTimestamp
  _isUpdatable
  _isDeletable
  isAdditionalTagAccessRequired
  isDocumentPoolNullDepartmentAccessible
  isDocDocumentAccess
  documentsDepartmentGroupId
  isPoDocumentAccess
  purchaseOrderDepartmentGroupId
  isTransDocumentAccess
  transactionsDepartmentGroupId
  isTaDocumentAccess
  travelAuthorizationDepartmentGroupId
  isAllBusinessUnits
  isAllWorkgroups
  isAllTagAccess
  isAllProjects
  dataAccessBusinessUnits {
    nodes {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      businessUnitId
      businessUnit {
        name
      }
      isPrimary
    }
  }
}
